var map = {
	"./GPSDashboard/GPSReporting.module": [
		"./src/app/GPSDashboard/GPSReporting.module.ts",
		"common",
		"GPSDashboard-GPSReporting-module"
	],
	"./Schools/schools.module": [
		"./src/app/Schools/schools.module.ts",
		"default~Schools-schools-module~vehicle-checkup-vehicle-checkup-module",
		"common",
		"Schools-schools-module"
	],
	"./vehicle-checkup/vehicle-checkup.module": [
		"./src/app/vehicle-checkup/vehicle-checkup.module.ts",
		"default~Schools-schools-module~vehicle-checkup-vehicle-checkup-module",
		"common",
		"vehicle-checkup-vehicle-checkup-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;